import { ConfiguratorUIElementStates, ConfiguratorUIElementWithChildrenState } from '@/stores/CfgUIElementState';

import React from 'react';

import { IUiCfgContainer } from '@canvas-logic/clp-api-types';
import { ContainerCfgUIElement } from '@/UiBuilder/elements/ContainerCfgUIElement/ContainerCfgUIElement';

let id = 0;

export class ContainerCfgUIElementState extends ConfiguratorUIElementWithChildrenState {
  constructor(children: Array<ConfiguratorUIElementStates>, viewElement: IUiCfgContainer) {
    super(children, viewElement);
  }

  render(): React.ReactElement {
    return (
      <ContainerCfgUIElement key={this.viewElement.id} viewElement={this.viewElement} childrenItems={this.children} />
    );
  }
}
